<div [class.lu-select__text]="selectedItem">
	<img *ngIf="imageField.value" [src]="imageField.value" [ngClass]="imageField.class" [alt]="labelField.value" />
	<span [ngClass]="labelField.class">{{ labelField.value }}</span>
</div>
